import fgInput from './components/UIComponents/Inputs/formGroupInput.vue'
import DropDown from './components/UIComponents/Dropdown.vue'
import vSelect from 'vue-select'
import Pagination from 'vue-pagination-2';

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
    install (Vue) {
        Vue.component('fg-input', fgInput)
        Vue.component('drop-down', DropDown)
        Vue.component('v-select', vSelect)
        Vue.component('pagination', Pagination);
    }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js